/**
 * 系统安装配置
 */
import React from 'react'
import {
  Bootstrap,
  Header,
  Footer,
  Messages
} from '../../components';

export default class Home extends React.Component {
  render() {
    return (
      <div>
        <Header/>
        <Bootstrap.Container>
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            {this.props.warnning === 'undefined' &&
              <Messages warn="Warning: this is test." />
            }
            <h1>系统初始化</h1>
          </div>
        </div>
        </Bootstrap.Container>
        <Footer/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/containers/setup/index.js